import { InputLabel, styled } from '@mui/material';
import React from 'react';
import { InputFieldProps } from './Input';
import { InputWrapper } from './InputWrapper';

const AttachStyled = styled(InputLabel)<{ bgcolor?: string }>`
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, bgcolor }) => bgcolor || theme.color.lightGrey};
  padding: 4px 10px;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.common.black};
  border-radius: 10px;
  margin: 4% 0;
`;

interface AttachFileProps extends InputFieldProps {
  bgcolor?: string;
}

export const AttachFile: React.FC<AttachFileProps> = ({
  children,
  info,
  id,
  width,
  alignitems,
  padding,
  bgcolor,
  margin,
  ...rest
}) => (
  <InputWrapper width={width} alignitems={alignitems} info={info}>
    <AttachStyled htmlFor={id} bgcolor={bgcolor}>
      {children}
    </AttachStyled>
    <input type="file" id={id} {...rest} style={{ display: 'none' }} />
  </InputWrapper>
);
